<template>
    <!-- All three hover actions (drag, edit, delete) live in one container
         pinned to the top-left of the cell. CSS shows the group on cell hover. -->
    <div v-if="!readOnly" class="menu-grid-cell__hover-actions">
        <button
            class="menu-grid-cell__btn menu-grid-cell__btn-drag"
            @mousedown.stop.prevent="$emit('drag-mousedown', $event)"
            :aria-label="$t('apps.configurator.menu-list.drag-handle')"
        >
            <feather-icon icon="MoveIcon" :style="iconStyle" />
        </button>
        <button
            class="menu-grid-cell__btn"
            @click.stop="$emit('edit')"
            :aria-label="$t('apps.configurator.menu-list.edit-item')"
        >
            <feather-icon icon="Edit2Icon" :style="iconStyle" />
        </button>
        <button
            class="menu-grid-cell__btn menu-grid-cell__btn-danger"
            @click.stop="$emit('delete')"
            :aria-label="$t('apps.configurator.menu-list.delete-item')"
        >
            <feather-icon icon="TrashIcon" :style="iconStyle" />
        </button>
    </div>
</template>

<script>
export default {
    name: 'CellHoverActions',
    props: {
        readOnly: { type: Boolean, default: false },
        // Icon size in pixels. MenuGrid uses 16 (w-4 h-4), MenuTabsEditor uses 14*ratio.
        iconSize:  { type: Number, default: 16 },
    },
    computed: {
        iconStyle() {
            return { width: this.iconSize + 'px', height: this.iconSize + 'px' }
        },
    },
}
</script>
